// KN base
import colors from './colors'

// KN helper functions
import boxShadow from '../functions/boxShadow'

const { black, white, primary, grey } = colors

const boxShadows = {
  xs: boxShadow(black.main, 0.15, [0, 2], [9, -5]),
  sm: boxShadow(black.main, 0.12, [0, 5], [10, 0]),
  md: `${boxShadow(black.light, 0.12, [0, 4], [6, -1])}, ${boxShadow(black.light, 0.07, [0, 2], [4, -1])}`,
  lg: `${boxShadow(black.light, 0.15, [0, 8], [26, -4])}, ${boxShadow(black.light, 0.06, [0, 8], [9, -5])}`,
  xl: boxShadow(black.light, 0.25, [0, 23], [45, -11]),
  xxl: boxShadow(black.main, 0.05, [0, 20], [27, 0]),
  inset: boxShadow(black.main, 0.075, [0, 1], [2, 0], 'inset'),
  navbarBoxShadow: `${boxShadow(white.main, 0.9, [0, 0], [1, 1], 'inset')}, ${boxShadow(
    black.main,
    0.05,
    [0, 20],
    [27, 0],
  )}`,
  buttonBoxShadow: {
    main: `${boxShadow(primary.contrastText, 1, [0, 0], [0, 3])}, ${boxShadow(
      primary.contrastText,
      1,
      [0, 1],
      [2, 0],
    )}`,
  },
  sliderBoxShadow: {
    thumb: boxShadow(black.main, 0.2, [0, 1], [13, 0]),
  },
  standardBoxShadow: 'rgba(0, 0, 0, 0.35) 0px 5px 15px',
  tabsBoxShadow: {
    indicator: boxShadow(grey[200], 1, [0, 1], [5, 1]),
  },
}

export default boxShadows
